import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 导入API接口模块
import api from './http'
// 导入vant组件库
import Vant from 'vant';
import 'vant/lib/index.css';
// 导入echarts图表库
import * as echarts from 'echarts'
// 导入重置样式
import './assets/css/reset.css';

// 引入lodash工具库
import lodash from 'lodash';
Vue.prototype.$lodash = lodash

Vue.use(Vant);

// 使用API接口模块
Vue.use(api)

Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')